import * as Common from '@/libs/Common';

const GetFormatDateString = (inputTime: Date, separation: string = '-'): string => {
    const year = inputTime.getFullYear();
    const month = Common.PaddingText((inputTime.getMonth() + 1).toString(), '0', 2);
    const date = Common.PaddingText(inputTime.getDate().toString(), '0', 2);
    return `${year}${separation}${month}${separation}${date}`;
};

const GetFormatDateTimeString = (inputTime: Date, separation: string = '-'): string => {
    const year = inputTime.getFullYear();
    const month = Common.PaddingText((inputTime.getMonth() + 1).toString(), '0', 2);
    const date = Common.PaddingText(inputTime.getDate().toString(), '0', 2);

    const hour = Common.PaddingText(inputTime.getHours().toString(), '0', 2);
    const minute = Common.PaddingText(inputTime.getMinutes().toString(), '0', 2);
    const second = Common.PaddingText(inputTime.getSeconds().toString(), '0', 2);
    return `${year}${separation}${month}${separation}${date} ${hour}:${minute}:${second}`;
};
export { GetFormatDateString, GetFormatDateTimeString };
